import { render, staticRenderFns } from "./CustomerMatchStandardConfirm.vue?vue&type=template&id=6edd81e7"
import script from "./CustomerMatchStandardConfirm.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchStandardConfirm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchStandardConfirm.vue?vue&type=style&index=0&id=6edd81e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports